import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsContentBlock = (props: Props) => {
  const { palette = 'cream', withBorder = false, withTopSpacing = true, children } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerResponsiveStyles = match([
    styles.containerXS,
    styles.containerXS,
    styles.containerLG,
  ]);
  const containerPaletteStyles = palette === 'kale' ? styles.containerKale : styles.containerCream;
  const containerWithBorderStyles = match([
    styles.containerWithBorderXS,
    styles.containerWithBorderSM,
  ]);

  const containerStyles = [
    containerResponsiveStyles,
    containerPaletteStyles,
    withBorder ? containerWithBorderStyles : undefined,
    withTopSpacing ? undefined : styles.containerWithoutSpacing,
  ];

  // ─────────────────────────────────────────────────────────────────────

  return <View style={containerStyles}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    gap: theme.spacing['6'],
    paddingTop: theme.spacing['6'],
    paddingHorizontal: theme.spacing['6'],
    paddingBottom: theme.spacing['10'],
  },
  containerWithoutSpacing: {
    paddingTop: 0,
  },
  containerLG: {
    gap: theme.spacing['6'],
    paddingVertical: theme.spacing['10'],
    paddingHorizontal: theme.spacing['16'],
  },
  containerWithBorderXS: {
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.KALE,
  },
  containerWithBorderSM: {
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.DARK_KALE,
  },
  containerCream: {
    backgroundColor: theme.colors.CREAM,
  },
  containerKale: {
    backgroundColor: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  palette?: Palette;
  withTopSpacing?: boolean;
  withBorder?: boolean;
}>;

type Palette = 'cream' | 'kale';
